import { createSelector } from '@ngrx/store';

import { SrcNotificationSetting } from '../../../projects/client/apis/src-notification-settings/src-notification-settings.model';

import { AppState } from '../app.state';
import { SrcNotificationSettingsState } from './src-notification-settings.state';

export namespace SrcNotificationSettingsSelectors {
  export const selectState = (state: AppState): SrcNotificationSettingsState =>
    state.srcNotificationSettings;

  export const selectData = createSelector(
    selectState,
    (state: SrcNotificationSettingsState): SrcNotificationSetting | null => state.data
  );

  export const selectIsEnabled = createSelector(
    selectState,
    (state: SrcNotificationSettingsState): boolean => state.data?.isEnabled ?? true
  );

  export const selectThreshold = createSelector(
    selectState,
    (state: SrcNotificationSettingsState): string => state.data?.threshold ?? '01:00:00'
  );

  export const selectLoading = createSelector(
    selectState,
    (state: SrcNotificationSettingsState): boolean => state.loading
  );

  export const selectLoaded = createSelector(
    selectState,
    (state: SrcNotificationSettingsState): boolean => state.loaded
  );
}
